(function () {
  const section = document.querySelector('[data-blog-recipes]');
  if (!section) return;

  const filters = section.querySelectorAll('[data-recipe-filter]');
  const cards = section.querySelectorAll('[data-recipe-tags]');
  const noResults = section.querySelector('[data-recipe-no-results]');

  function setActive(button) {
    filters.forEach((btn) => {
      btn.classList.toggle('is-active', btn === button);
      btn.setAttribute('aria-pressed', btn === button ? 'true' : 'false');
    });
  }

  function applyFilter(tag) {
    let visible = 0;

    cards.forEach((card) => {
      const tags = (card.getAttribute('data-recipe-tags') || '')
        .split(',')
        .map((value) => value.trim())
        .filter(Boolean);

      const show = tag === 'all' || tags.includes(tag);
      card.hidden = !show;
      if (show) visible += 1;
    });

    if (noResults) {
      noResults.classList.toggle('is-visible', visible === 0);
    }
  }

  filters.forEach((button) => {
    button.addEventListener('click', () => {
      setActive(button);
      applyFilter(button.getAttribute('data-recipe-filter') || 'all');
    });
  });
})();
